import {GiphyItem, giphySearch} from "./giphy"
import {Image} from "./Image"
import {useConfig} from "./hooks/useConfig"
import {usePatchState} from "./hooks/usePatchState"
import React, {ReactNode} from "react"
import {SmileType} from "./Images";

interface GiphyWidgetState {
    query: string
    isLoading: boolean
    error: Error | null
    abortController: AbortController | null
    items: GiphyItem[]
}

const initialState: GiphyWidgetState = {
    query: "",
    isLoading: false,
    error: null,
    abortController: null,
    items: [],
}

interface GiphyWidgetProps {
    onClipboard: (type: SmileType, url: string) => void
}

export const GiphyWidget = (props: GiphyWidgetProps) => {
    const config = useConfig()
    const [state, patchState] = usePatchState<GiphyWidgetState>(initialState)

    const search = () => {
        if(state.query.length < 3) {
            return
        }

        if (state.abortController !== null) {
            state.abortController.abort()
        }

        const abortController = new AbortController()

        patchState({
            isLoading: true,
            error: null,
            abortController: abortController,
        })

        giphySearch(config.giphyApiKey, state.query, abortController.signal)
            .then(res => {
                if (res.meta.status !== 200) {
                    patchState({
                        isLoading: false,
                        error: new Error("Ошибка получения результатов"),
                        items: [],
                    })

                    return
                }

                patchState({
                    isLoading: false,
                    error: null,
                    items: res.data,
                })
            })
            .catch(err => {
                patchState({
                    isLoading: false,
                    error: err,
                    items: [],
                })
            })

        console.log("Search", state.query)
    }

    let resultElem: ReactNode = undefined

    if (state.isLoading) {
        resultElem = (
            <div style={{padding: '1rem'}}>Поиск</div>
        )
    } else if (state.error !== null) {
        resultElem = (
            <div style={{padding: '1rem', color: 'red'}}>Error: {state.error.message}</div>
        )
    } else {
        const imagesElems: ReactNode = state.items.map(item => {
            return <Image key={item.id} type="image" url={item.images.fixed_height.url} data={item.images.fixed_height.url} onClipboard={props.onClipboard} />
        })

        resultElem = (
            <div className="tab-images">
                {imagesElems}
            </div>
        )
    }

    const onInputChanged = (value: string) => {
        patchState({
            query: value,
        })
    }

    const onInputKeyDown = (key: string) => {
        if (key === "Enter") {
            search()
        }
    }

    const disabled = state.isLoading

    return (
        <div>
            <div style={{padding: '1rem', paddingBottom: 0}}>
                <input
                    type="text"
                    value={state.query}
                    disabled={disabled}
                    onChange={(e) => onInputChanged(e.target.value)}
                    onKeyDown={(e) => onInputKeyDown(e.key)}
                />
                <button
                    disabled={disabled}
                    onClick={() => search()}
                >
                    Искать
                </button>
            </div>
            {resultElem}
        </div>
    )
}